import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevicesComponent } from './devices.component';
import { DevicesRoutingModule } from './devices-routing.module'
import { ListDevicesComponent } from '../components/list-devices/list-devices.component';
import {AddNewDeviceComponent} from '../components/add-new-device/add-new-device.component';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    DevicesRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatMenuModule
  ],
  declarations: [DevicesComponent, ListDevicesComponent, AddNewDeviceComponent]
})
export class DevicesModule { }
